import { render } from "./AppManageDeveloperSettings.vue?vue&type=template&id=2123dbea"
import script from "./AppManageDeveloperSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./AppManageDeveloperSettings.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/AppManage/AppManageDeveloperSettings.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2123dbea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2123dbea', __exports__)) {
    api.reload('2123dbea', __exports__)
  }
  
  module.hot.accept("./AppManageDeveloperSettings.vue?vue&type=template&id=2123dbea", () => {
    api.rerender('2123dbea', render)
  })

}


export default __exports__